import { dom } from './dom.js';
import { MAX_SCORE_BY_LEVEL, PERFECT_ERROR_BY_LEVEL } from './constants.js';
import { state } from './state.js';

export function getMaxScoreForLevel(level) {
    return MAX_SCORE_BY_LEVEL[level - 1];
}

export function getPerfectErrorForLevel(level) {
    return PERFECT_ERROR_BY_LEVEL[level - 1];
}

export function getMaxErrorForLevel(level) {
    return 2.0 + (level - 1) * 0.25;
}

export function getTotalScore() {
    return Object.values(state.scoresByLevel).reduce((sum, score) => sum + score, 0);
}

export function updateTotalScoreDisplay() {
    if (state.gameMode === 'time' && state.timeRun) {
        dom.totalScoreEl.textContent = state.timeRun.correctCount;
        return;
    }
    dom.totalScoreEl.textContent = getTotalScore();
}

export function calculateScore(yourError, level) {
    const maxScoreForLevel = getMaxScoreForLevel(level);
    const maxError = getMaxErrorForLevel(level);
    const perfectError = getPerfectErrorForLevel(level);

    let problemPoints = 0;

    if (yourError <= perfectError) {
        problemPoints = maxScoreForLevel;
    } else if (yourError < maxError) {
        const falloffRatio = (yourError - perfectError) / (maxError - perfectError);
        problemPoints = maxScoreForLevel * (1 - falloffRatio);
    }

    const roundedProblemPoints = Math.round(problemPoints);
    state.submittedLevels.add(level);
    if (roundedProblemPoints > 0) {
        state.passedLevels.add(level);
    }
    const previousBest = state.scoresByLevel[level];
    if (previousBest === undefined || roundedProblemPoints > previousBest) {
        state.scoresByLevel[level] = roundedProblemPoints;
    }

    updateTotalScoreDisplay();

    let resultHTML = `Correct: ${state.solution.minDistance.toFixed(1)} NM. `;
    if (roundedProblemPoints > 0) {
        resultHTML += `<span class="text-green-400">Points: +${roundedProblemPoints}</span>`;
    } else {
        resultHTML += `<span class="text-gray-400">Points: 0</span>`;
    }
    dom.resultTextEl.innerHTML = resultHTML;
    return roundedProblemPoints;
}
